import styled from "styled-components"
import Icon from "@irati/ui/src/Icon"

const StyledIcon = styled(Icon)`
  position: relative;
  bottom: 1px;
`

export default StyledIcon
